import { AfterViewInit, Component, Input } from '@angular/core';
import { MuiInputDirective } from '../input/mui-input.directive';
import { PasswordCondition } from './password-condition';


@Component({
  selector: 'mui-password-checker',
  templateUrl: './password-checker.component.html',
  styleUrls: ['./password-checker.component.scss']
})
export class MuiPasswordChecker implements AfterViewInit {
  @Input() inputField!: MuiInputDirective;
  @Input() conditions: PasswordCondition[] = [
    {
      conditionLabel: 'at least 8 characters',
      expression: /^.{8,}$/
    },
    {
      conditionLabel: 'uppercase and lowercase letters',
      expression: /^(?=.*[a-z])(?=.*[A-Z]).*/
    },
    {
      conditionLabel: 'at least 1 number',
      expression: /.*[0-9].*/
    },
    {
      conditionLabel: 'at least 1 special symbol',
      expression: /.*[\W].*/
    }
  ];

  @Input() weakPasswordLabel = 'Password is not strong enough.';
  @Input() strongPasswordLabel = 'Password is strong.';
  @Input() conditionsTitle = 'Your Password must contain:';
  private validConditionCount = 0;

  isValid(): boolean {
    return this.conditions.length === this.validConditionCount;
  }

  ngAfterViewInit(): void {
    this.inputField.ngControl?.valueChanges?.subscribe((value) => {
      this.conditions.forEach((condition: PasswordCondition) => {
        condition.isValid = value?.match(condition.expression);
      });
      this.validConditionCount = this.conditions.filter((condition) => condition.isValid)?.length;
    });
  }

  getProgressClassForBar(barIndex: number): 'condition-valid' | 'condition-invalid' | 'condition-insufficient' | 'condition-empty' {
    if (barIndex < this.validConditionCount) {
      if (this.conditions.length / 2 > this.validConditionCount) {
        return 'condition-invalid';
      } else {
        return this.conditions.length === this.validConditionCount ? 'condition-valid' : 'condition-insufficient';
      }
    } else {
      if (this.validConditionCount === 0 && barIndex === 0) {
        return 'condition-invalid';
      }
      return 'condition-empty';
    }
  }
}
